module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('x-header', {
    staticStyle: {
      "background-color": "#2b3033"
    },
    attrs: {
      "left-options": {
        backText: ""
      }
    }
  }, [_vm._v("\n    域名绑定\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "mui-inner-wrap"
  }, [_c('div', {
    staticClass: "alert-warn margin-bottom-20 domain-list"
  }, [_c('p', {
    staticClass: "line-left-dot"
  }, [_vm._v("您最多可绑定20个域名。")]), _vm._v(" "), (_vm.vhostInfo.free === 'free') ? _c('div', [_c('p', [_vm._v("\n          免费虚拟主机只能绑定在阿贝云注册的域名。\n        ")]), _vm._v(" "), _c('p', [_vm._v("\n          域名绑定后会在2分钟左右自动解析生效。\n        ")])]) : _vm._e(), _vm._v(" "), (_vm.vhostInfo.free === 'vip') ? _c('div', [_c('p', [_vm._v("\n          如果您的域名是在阿贝云注册，绑定后会在2分钟左右自动解析生效。\n        ")]), _vm._v(" "), _c('p', [_vm._v("\n          非阿贝云注册的域名请按照如下解析：\n        ")]), _vm._v(" "), _c('p', [_vm._v("\n          如果域名未备案，解析别名记录（CNAME）到：cr" + _vm._s(_vm.vhostInfo.sk_domain.replace('sk', '')) + "\n        ")]), _vm._v(" "), (!_vm.vhostInfo.ip_bind) ? _c('p', [_vm._v("\n          如果域名已备案，解析别名记录（CNAME）到：sk" + _vm._s(_vm.vhostInfo.sk_domain.replace('sk', '')) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.vhostInfo.ip_bind) ? _c('p', [_vm._v("\n          如果域名已备案，解析主机记录（A）到：" + _vm._s(_vm.vhostInfo.ip_bind) + "\n        ")]) : _vm._e()]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "large-add-button"
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.Add
    }
  }, [_c('span'), _vm._v("\n      + 添加绑定\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "mui-inner-wrap"
  }, [_c('aside'), _vm._v(" "), _c('div', {
    attrs: {
      "id": "contentBox"
    }
  }, [_c('div', {
    staticClass: "mui-content"
  }, [(_vm.nameList.length > 0) ? _c('div', {
    staticClass: "common-list-box form-group"
  }, _vm._l((_vm.nameList), function(item, index) {
    return _c('div', {
      staticClass: "form-group-item",
      on: {
        "click": function($event) {
          _vm.Mange(item.id)
        }
      }
    }, [_c('span', {
      staticClass: "form-label"
    }, [_vm._v("\n              http://" + _vm._s(item.DomainName) + "\n            ")]), _vm._v(" "), _c('span', {
      staticClass: "form-content verify-method  text-right"
    }, [_c('a', {
      staticClass: "right-del del-icon act-icon",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.Delete(item.id)
        }
      }
    })])])
  })) : _vm._e()])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-161c7b2e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/console/hostoperate/domainname.vue
// module id = g0+i
// module chunks = 1